import { v4 as uuidv4 } from "uuid";
export class AssetTypeModel {
    constructor() {
        this.id = `${uuidv4()}`;
        this.code = "";
        this.name = "";
        this.assetCategoryId = "";
        this.propertiesFound = 0;
        this.assetCategoryName = "";
    }
}
export default class AssetType extends AssetTypeModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
